/**
 * Biconomy Exchange Metadata
 *
 * Configuration, documentation links, and notes for the Biconomy exchange.
 */

import { BICONOMY_WS_CHANNELS, BICONOMY_WS_TOPOLOGY } from './ws';

import type { ExchangeId, ExchangeMetadata } from '../../lib/types';

export const BICONOMY_METADATA: ExchangeMetadata = {
  id: 'biconomy' as ExchangeId,
  restDocs: ['https://api.biconomy.com'],
  wsDocs: ['https://api.biconomy.com'],
  wsTopology: BICONOMY_WS_TOPOLOGY,
  wsChannels: BICONOMY_WS_CHANNELS,
  notes: [
    'Uses Biconomy v1 spot API. Symbols are uppercase with an underscore (e.g. BTC_USDT).',
    'Public REST market responses are raw (no {code,msg,data} wrapper).',
    'No per-symbol ticker endpoint — /api/v1/tickers returns ALL pairs; filter by symbol.',
    'REST kline timestamps are in MILLISECONDS with [ts,open,high,low,close,volume] ordering.',
    'WebSocket is CoinEx/ViaBTC JSON-RPC style; client must send server.ping keep-alives.',
    'WS kline timestamps are in SECONDS with [time,open,close,high,low,volume,deal,symbol] ordering.',
    'Data-only / display integration: market data + symbol info only (no order placement).',
  ],
};
